import { json2csv_fn, toThousands, getExportName_fn, weekLocaleArray } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";


function currencyFormat(value) {
  return value !== null && value !== undefined ? "¥" + toThousands(value) : "";
}

export function exportCSV_fn(datas, startDate, endDate) {
  let csvData = [];
  const fields = [
    {
      label: "",
      value: "", // 第一列无表头，数据从 row[""] 取
    },
    {
      label: "システム利用料",
      value: "systemFee",
    },
    {
      label: "取引枚数(新规·更新合計)",
      value: "count",
    },
    {
      label: "壳上合計",
      value: "totalAmount",
    },
    {
      label: "visa/master手数料",
      value: "totalAmountFee",
    },
    {
      label: "GMO処理料(卜ランザクション·売上)",
      value: "gmoFee",
    },
  ];
  if (datas.length > 0) {
    datas.forEach(item => {
      const row = {
        ...item,
        systemFee: currencyFormat(item.systemFee),
        totalAmount: currencyFormat(item.totalAmount),
        totalAmountFee: currencyFormat(item.totalAmountFee),
        gmoFee: currencyFormat(item.gmoFee),
      };
      row[""] = item.brandName; // 第一列数据，表头为空
      csvData.push(row);
    });
    json2csv_fn(
      csvData, fields,
      getExportName_fn(
        "会員会費 決済サマリー",
        "",
        "",
        "",
        `${moment(startDate).format("YYYY-MM-DD")} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format("YYYY-MM-DD")} （${weekLocaleArray[moment(endDate).day()]}）`,
        moment().format("YYYYMMDDHHmm")
      )
    );
  }
}